import styled from 'styled-components';
import * as imagePopupCss from '../imagePopup/ImagePopup.css';
import {BGImageCenter, BLACK, DEFAULT_COLOR, LIGHT_BLUE, mobileMedia, WHITE} from '../../globalVariables/GlobalVariables';
import {popUpTop} from '../newPopup/topPopup/TopPopup.css';
import {popUpBody} from '../newPopup/mobilePopup/MobilePopup.css';
import {dFlex, dFlexCenter} from '../../globalVariables/GlobalFlex';
import {close, title as popTitle} from '../newPopup/innerPop/InnerPop.css';
import {arrowDark} from '../../assets/symbols/symbols/Symbols.css';

export const image = styled(imagePopupCss.image)``;

export const wrapPopup = styled.div`
    ${popTitle}{
        color: ${BLACK}
    }
    ${close}{
        ${BGImageCenter(arrowDark,'16px')}
    }
    ${popUpTop}{
        height: 60px;
    }
    ${popUpBody}{
        height: max-content;
        width: max-content;
    }
`;

export const wrapAll = styled.div`
    width: 285px;
    padding: 20px;
    ${imagePopupCss.image}{
        height: 130px;
        width: 130px;
    }
    ${popUpTop}{
        background-color: ${LIGHT_BLUE};
        border-radius: 5px 5px 0 0;
    }
`;
export const top = styled(imagePopupCss.top)`
    position: relative;
    width: 100%;
    inset-block-start: 60px;
    margin-block-end: 40px;
    border-radius: 0;
`;
export const buttons = styled(imagePopupCss.buttons)``;
export const details = styled(imagePopupCss.details)``;

export const title = styled.div`
    font-size: 12px;
    line-height: 100%;
    letter-spacing: 1.8px;
    margin-block: 20px;
`;

export const share= styled.div`
    ${dFlex};
    height: 100%;
    width:100%;
    ${mobileMedia}{
        display:block;
    }
`;

export const shareDetails= styled.div`
    width: 100%; 
    height: 100%;
    padding-top:20px;
    ${mobileMedia}{
        padding-top:10px;
        width: 75%;
        margin:0 auto; 
        min-height: 220px;
        height: calc(100% - 300px);
    }
`;
export const shareShare= styled.div`
    height:140px;
    ${dFlex};
    flex-wrap: wrap;
`;
export const shareShareBtn=styled.div`
    background: ${DEFAULT_COLOR};
    font-size: 18px;
    font-weight: 600;
    width: max-content;
    color: ${WHITE};
    padding: 7px 30px;
    border-radius: 20px;
    margin: 0 auto;
`;
export const shareItem= styled.div`
    background-color: ${WHITE};
    font-size:12px;
    text-align:center;
    width: 77px;
`;

export const shareItemImg= styled.div<{img:string}>`
   ${p=>BGImageCenter(p.img, '30px 30px')}
   width:100%;
   height:calc(100% - 20px);
   cursor:pointer;
`;
export const shareItemText= styled.div`
    
`;
export const shareClose= styled.div`
    position: absolute;
    inset-block-end: 20px;
    margin-top: 10px;
    width: 100%;
    ${dFlexCenter};
`;
